import { Controller } from "@hotwired/stimulus";

// Manages the agreement type card selector: updates visual state when user clicks/selects.
// Cards show selected state (border, background, checkmark) based on the radio value.
export default class extends Controller {
  static targets = ["card", "check", "radio"];

  connect() {
    this.updateFromRadios();
  }

  select(event) {
    this.updateFromRadios();
  }

  updateFromRadios() {
    const selectedRadio = this.radioTargets.find((r) => r.checked);
    const selectedValue = selectedRadio ? selectedRadio.value : null;

    this.cardTargets.forEach((card, index) => {
      const isSelected = card.dataset.typeValue === selectedValue;
      this.setCardSelected(card, isSelected);
      if (this.hasCheckTarget && this.checkTargets[index]) {
        this.checkTargets[index].classList.toggle("hidden", !isSelected);
      }
    });
  }

  setCardSelected(card, selected) {
    if (selected) {
      card.classList.add("border-primary-500", "bg-primary-50", "dark:bg-primary-900/20", "ring-2", "ring-primary-500");
      card.classList.remove("border-gray-200", "dark:border-gray-600");
    } else {
      card.classList.remove("border-primary-500", "bg-primary-50", "dark:bg-primary-900/20", "ring-2", "ring-primary-500");
      card.classList.add("border-gray-200", "dark:border-gray-600");
    }
  }
}
